import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axois';

const PaymentCallback = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const isVerifying = useRef(false); // Use ref to prevent multiple calls

    useEffect(() => {
        const verifyPayment = async () => {
            if (isVerifying.current) {
                console.log('Verification already in progress. Skipping duplicate call.');
                return;
            }
            isVerifying.current = true; // Set flag to true to block further calls

            try {
                const urlParams = new URLSearchParams(window.location.search);
                const reference = urlParams.get('reference');

                if (!reference) {
                    console.error('No payment reference found in URL. Redirecting to error page.');
                    setError('No payment reference found.');
                    setTimeout(() => navigate('/payment-failed'), 3000);
                    return;
                }

                // Check if this reference has already been verified
                const verifiedReferences = JSON.parse(sessionStorage.getItem('verifiedReferences') || '[]');
                if (verifiedReferences.includes(reference)) {
                    console.log('Payment reference already verified. Skipping API call.');
                    return;
                }

                console.log('Calling verify API for reference:', reference);
                const response = await api.get(`/paystack/callback?reference=${reference}`);

                if (response.data.success) {
                    // Mark this reference as verified
                    sessionStorage.setItem('verifiedReferences', JSON.stringify([...verifiedReferences, reference]));

                    // Use the redirect_url from backend response
                    const redirectUrl = response.data.redirect_url || '/ProfilePage';
                    // If guest, redirect to /payment-success with booking_id
                    if (redirectUrl.startsWith('/payment-success')) {
                        navigate(redirectUrl);
                    } else {
                        navigate(redirectUrl);
                    }
                } else {
                    throw new Error(response.data.message || 'Payment verification failed');
                }

            } catch (error) {
                console.error('Error during payment verification:', error);
                setError('Payment verification failed. Please contact support.');
                // Redirect to error page after 3 seconds
                setTimeout(() => navigate('/payment-failed'), 3000);
            } finally {
                isVerifying.current = false; // Reset flag after verification attempt
            }
        };

        verifyPayment();
        // Only run on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    if (error) {
        return (
            <div className="payment-callback error">
                <h2>Payment Verification Failed</h2>
                <p>{error}</p>
                <p>Redirecting to error page...</p>
            </div>
        );
    }

    return (
        <div className="payment-callback">
            <h2>Verifying your payment...</h2>
            <p>Please wait while we confirm your payment.</p>
        </div>
    );
};

export default PaymentCallback;